import { CommonDependency } from '@/dependency';
import { useQuery } from 'react-query';

export type ProtocolDetail = {
  id: string;
  logo_url: string;
  name: string;
};

export const useProtocolList = (chainId?: string) => {
  return useQuery<{ protocols: ProtocolDetail[] }>(
    ['protocol-list', chainId],
    async () => CommonDependency.api.getProtocolList(chainId),
    {
      enabled: !!chainId,
    },
  );
};
